import 'babel-polyfill'
import Vue from 'vue'
import VueValidator from 'vue-validator'
import App from './App'
import '!vue-style!css!bootstrap/dist/css/bootstrap.css'
import '!vue-style!css!font-awesome/css/font-awesome.css'
import '!vue-style!css!animate.css'
import '!vue-style!css!./assets/css/common.css'
import $ from 'jquery'
window.$ = $
import 'bootstrap'
import Resource from 'vue-resource'
import Router from 'vue-router'
import VMoment from 'vue-moment'
import Slick from './directives/v-slick'
import Popover from './directives/v-popover'
import Affix from './directives/v-affix'
import Day from './filters/day.js'
import Ellipsis from './filters/ellipsis'
import FancyBox from './directives/v-fancybox'
import Cookie from 'js-cookie'
Vue.use(VueValidator)
Vue.use(Resource)
Vue.use(Router)
Vue.use(Slick)
Vue.use(VMoment)
Vue.use(Day)
Vue.use(Popover)
Vue.use(Affix)
Vue.use(FancyBox)
Vue.use(Ellipsis)

Vue.http.headers.common['Sensors-Platform'] = 'PC'
let isMember = Cookie.get('isMember') || false

var checkhref = window.location.href
var serverurl = 'https://54traveler.datasink.sensorsdata.cn/sa?project=production&token=b1522d42d03ffb37'
if (checkhref.indexOf('test') >= 0 || checkhref.indexOf('localhost') >= 0) {
  serverurl = 'http://54traveler.datasink.sensorsdata.cn/sa?project=default&token=b1522d42d03ffb37'
}
var sensors = require('sa-sdk-javascript')
sensors.init({
  server_url: serverurl,
  show_log: false,
  is_track_single_page: true,
  use_client_time: true,
  send_type: 'beacon',
  heatmap: {
    clickmap: 'default',
    scroll_notice_map: 'default',
    get_vtrack_config: false
  }
})

sensors.registerPage({
  platform_type: 'PC',
  is_member: function () {
    return isMember
  }
})

sensors.quick('autoTrack')

import sensorscommon from './libs/sensorscommon'

Vue.prototype.$sensors = sensors
Vue.prototype.sensorscommon = sensorscommon

const router = new Router({
  history: true,
  saveScrollPosition: false
})

router
  .map({
    '/': {
      component: require('./views/Second')
    },
    '/city/:city': {
      component: require('./views/Second')
    },
    '/we': {
      component: require('./views/We')
    },
    '/mfirst': {
      component: require('./views/Mfirst')
    },
    '/online': {
      component: require('./views/Online')
    },
    '/weRule': {
      component: require('./views/weRule')
    },
    '/route/:id': {
      component: require('./views/Third')
    },
    '/feedback': {
      component: require('./views/Feedback')
    },
    '404': {
      component: require('./views/404')
    }
  })
  .redirect({
    '*': '/404'
  })
  .beforeEach((transition) => {
    let { next } = transition
    window.scrollTo(0, 0)
    next()
  })

Vue.http.interceptors.push(() => {
  return {
    request (request) {
      return request
    },
    response (response) {
      if (response.status === 404) {
        // router.replace('/404')
      }
      return response
    }
  }
})

router.start(App, '#app')



/** WEBPACK FOOTER **
 ** ./src/main.js
 **/